<script lang="ts">
  import Heading from "$lib/admin/components/blocks/helpers/Heading.svelte";

  export let props: any = null;

  function getListClass() {
    let baseClass = "list-inside";

    // Handle icon lists or lists with listStyle property
    if (props.listType === "icon" || props.listStyle) {
      if (props.listIcon) {
        baseClass += ` list-image-${props.listIcon}`;
      } else if (props.listStyle) {
        baseClass += ` list-image-${props.listStyle}`;
      } else if (props.listType === "icon") {
        baseClass += " list-image-fire"; // fallback is "fire" if none is set
      }
    } else if (props.listType === "ordered" || props.listType === "ol") {
      baseClass += " list-decimal";
    } else if (props.listType === "bullet" || props.listType === "ul") {
      baseClass += " list-image-fire";
    }

    return baseClass;
  }

  function getItemContent(item: any): string {
    if (typeof item === "string") {
      return item;
    } else if (typeof item === "object") {
      if (item && item.text !== undefined) {
        return item.text;
      }
    }
    return "";
  }

  function hasParaTags(content: string): boolean {
    return content.trim().startsWith("<p>") && content.trim().endsWith("</p>");
  }

  function getHtmlElement(): string {
    if (props.htmlElement) {
      return props.htmlElement;
    }

    if (props.listType === "ordered" || props.listType === "ol") {
      return "ol";
    } else {
      return "ul";
    }
  }
</script>

<div class="content-grid {props?.styling?.marginTop ?? ''} {props?.styling?.marginBottom ?? ''}" id="block-list">
  <Heading {props} />

  <svelte:element this={getHtmlElement()} class={getListClass()}>
    {#if props.listItems}
      {#each props.listItems as item}
        <li>
          {#if hasParaTags(getItemContent(item))}
            {@html getItemContent(item)}
          {:else}
            <p>{@html getItemContent(item)}</p>
          {/if}
        </li>
      {/each}
    {/if}
  </svelte:element>
</div>
